<template>
  <div class="addmap-container">
    <div class="amap-page-container">
      <div class="input-search">
        <el-input v-model="address" class="input-address" placeholder="请输入检索地址"></el-input>
        <el-button icon="el-icon-search" class="btn-search" @click="searchMap()" size="medium"/>
      </div>
      <el-amap vid="amap" class="amap-demo" mapStyle="amap://styles/light" :center="center" :zoom="zoom" :events="events">
        <!-- 点击显示标记 -->
        <el-amap-marker
          v-for="(marker, index) in markers"
          :key="marker.index"
          :position="marker.position"
          :icon="marker.icon"
          :title="marker.title"
          :events="marker.events"
          :visible="marker.visible"
          :draggable="marker.draggable"
          :vid="index"
        />
      </el-amap>
    </div>
  </div>
</template>
<script>
import store from '@/store'
export default {
  name: 'AddMap',
  props: ['nowlng', 'nowlat'],
  data() {
    const self = this
    return {
      map: {
        address: store.state.user.account.address,
        lng: store.state.user.account.center[0],
        lat: store.state.user.account.center[1]
      },
      // 地图相关
      address: store.state.user.account.address, // 获取的位置
      zoom: 15, // 地图缩放
      center: store.state.user.account.center, // 初始中心
      lng: store.state.user.account.center[0], // 经纬度
      lat: store.state.user.account.center[1],
      loaded: false,
      markers: [{ position: store.state.user.account.center }], // 点击显示的标记默认的定位
      // 点击地图获取当前位置并显示标记
      events: {
        click(e) {
          self.chaadd(e.lnglat)
        }
      }
    }
  },
  computed: {
    nowLnglat() {
      const lng = this.nowlng
      const lat = this.nowlat
      return { lng, lat }
    }
  },
  watch: {
    nowLnglat: {
      handler: function(newVal, oldVal) {
        if (newVal.lng && newVal.lat) {
          this.chaadd(newVal)
        }
      }
    }
  },
  async created() {
    const lng = this.nowlng
    const lat = this.nowlat
    if (lng && lat) {
      await this.chaadd({
        lng,
        lat
      })
    }
    this.$emit('mapDing', this.map)
  },
  methods: {
    searchMap() {
      const that = this
      const address = this.address
      that.map.address = that.address
      var geocoder = new window.AMap.Geocoder({
        city: '全国'
      })
      geocoder.getLocation(address, function(status, result) {
        if (status === 'complete' && result.geocodes.length) {
          var lnglat = result.geocodes[0].location
          that.center = [lnglat.lng, lnglat.lat]
          that.lng = lnglat.lng
          that.lat = lnglat.lat
          that.markers = [{
            position: that.center
          }]
          that.map.lng = that.lng
          that.map.lat = that.lat
        } else {
          that.address = ''
          that.lng = null
          that.lat = null
          that.$message({
            type: 'error',
            message: '根据地址查询位置失败，所选地点不支持！'
          })
        }
      })
      that.$emit('mapDing', that.map)
    },
    chaadd(e) {
      const self = this
      const { lng, lat } = e
      self.lng = lng
      self.lat = lat
      self.map.lng = self.lng
      self.map.lat = self.lat
      self.center = [self.lng, self.lat]
      self.loaded = true
      self.markers = [{ position: self.center }]
      var geocoder = new window.AMap.Geocoder({
        city: '全国'
      })
      function regeoCode() {
        var lnglat = [lng, lat]
        geocoder.getAddress(lnglat, function(status, result) {
          if (status === 'complete' && result.regeocode) {
            self.address = result.regeocode.formattedAddress
            self.map.address = self.address
          } else {
            self.address = undefined
            self.lng = undefined
            self.lat = undefined
            self.$message({
              type: 'error',
              message: '获取地图经纬度失败，所选地点不支持！'
            })
          }
        })
      }
      regeoCode()
      self.$emit('mapDing', self.map)
    }
  }
}
</script>
<style lang="less">
.addmap-container{
  height: 325px;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  .amap-page-container {
    height: 325px;
    width: 100%;
    position: relative;
    .input-search {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 5;
      width: 320px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 99999999999;
      .input-address{
        width: 272px !important;
        .el-input__inner{
          background-color: #fff !important;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right: 0 !important;
        }
      }
      .btn-search{
        box-sizing: border-box;
        height: 40px;
        width: 50px;
        background: #2d8cf0 !important;
        border-color: #2d8cf0 !important;
        color:#fff !important;
        display: flex;
        padding: 0 !important;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 0;
         border-bottom-left-radius: 0;
      }
    }
  }
}
</style>
